export default __webpack_public_path__ + "f027f32d300028af4206ba00d1fcc08f.svg";